import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { urlApi } from '../Constants/Global';

const SectionCertify = (props) => {
  return (
    <>
      <section>
        <Container>
          <Row className="mb-5 mt-5">
            <Col lg={12} className="text-center">
              {props.contents.map((item, index) => (
                <img src={urlApi + '/storage/media/' + item.set2} alt="certify" className="logo-ghp mx-3 mx-md-5" />
              ))}
            </Col>
            <Col
              lg={{ span: 6, offset: 3 }}
              md={{ span: 8, offset: 2 }}
              sm={{ span: 10, offset: 1 }}
              xs={{ span: 10, offset: 1 }}
              className="text-center mt-4">
              <h2 className='font-custom'>
                <b>บริษัท เคทีเอ็น พลาสแพค จำกัด</b>
              </h2>
              <h2 className='font-custom'>โรงงานผลิตภายใต้ระบบมาตรฐาน ISO 9001 : 2015 และ GHPs (Good Hygiene Practices)</h2>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

SectionCertify.defaultProps = {
  contents: []
}

export default SectionCertify